module.exports = __webpack_public_path__ + "img/header-memoireRingsPlatinum.024e54e.jpg";